import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IBrandLead) {
    (function(Source) {
        /**
     * @deprecated
     */ Source["BRAND_APPLIED"] = "BRAND_APPLIED";
        /**
     * @deprecated
     */ Source["SALES"] = "SALES";
        Source["SALES_SOURCED"] = "SALES_SOURCED";
        Source["REFERRAL"] = "REFERRAL";
        Source["LEAD_GENIUS"] = "LEAD_GENIUS";
        Source["PRODUCT_MATCHING"] = "PRODUCT_MATCHING";
        Source["EVENT"] = "EVENT";
        Source["ORGANIC"] = "ORGANIC";
        Source["DIRECT_MAIL"] = "DIRECT_MAIL";
        Source["DIGITAL_ADS"] = "DIGITAL_ADS";
        Source["PRESS"] = "PRESS";
        Source["BRAND_REFERRAL"] = "BRAND_REFERRAL";
        Source["INTERNATIONAL_TRADESHOW"] = "INTERNATIONAL_TRADESHOW";
        Source["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
        Source["RETAILER_REFERRAL"] = "RETAILER_REFERRAL";
        Source["FAIRE_EMPLOYEE"] = "FAIRE_EMPLOYEE";
        Source["MAKER_SCORING"] = "MAKER_SCORING";
        Source["CHARM_IO"] = "CHARM_IO";
        Source["OUTBOUND"] = "OUTBOUND";
        Source["OUTBOUND_OLD"] = "OUTBOUND_OLD";
        Source["FAIRE_BLOG"] = "FAIRE_BLOG";
        Source["ZOOMINFO"] = "ZOOMINFO";
        Source["PURCHASE_ORDER"] = "PURCHASE_ORDER";
    })(IBrandLead.Source || (IBrandLead.Source = {}));
    IBrandLead.build = function(partial) {
        return _object_spread({
            secondary_categories: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IBrandLead || (IBrandLead = {}));
export var IBrandLead;
